__webpack_require__.p = "https://assets.getmyboat.com/_next/";